import { render } from "./ScheduleSection.vue?vue&type=template&id=b1210bc2&scoped=true"
import script from "./ScheduleSection.vue?vue&type=script&lang=js"
export * from "./ScheduleSection.vue?vue&type=script&lang=js"

import "./ScheduleSection.vue?vue&type=style&index=0&id=b1210bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1210bc2"]])

export default __exports__